import AiStars from '@/components/icons/AiStars';
import {Link} from '@/i18n/routing';
import Image from 'next/image';
import {IMGPI} from '@/config';

export default function ButtonOtto() {

  return (
    <Link
      // @ts-expect-error
      href={{pathname: '/otto'}}
    >
      <div className="relative lg:hidden">
        <Image
          draggable={false}
          width={40}
          height={40}
          src={IMGPI + '/otto.png'}
          alt="Otto Propic"
        />
        <AiStars width={15} height={10} className="absolute top-0 left-0" />
      </div>
    </Link>
  )
};